import { type ComponentProps } from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { Scrollspy, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationIngredientsGridContainer = (
  props: CustomizationIngredientsGridSectionProps,
) => {
  const { children, containerStyle, contentContainerStyle, ...restProps } = props;

  const { match } = useResponsive();

  const contentContainerStyles = [
    styles.contentContainer,
    match([styles.contentContainerXS]),
    contentContainerStyle,
  ];

  return (
    <View style={[styles.outerContainer, containerStyle]}>
      <Scrollspy.ScrollView contentContainerStyle={contentContainerStyles} {...restProps}>
        {children}
      </Scrollspy.ScrollView>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    backgroundColor: theme.colors.OATMEAL,
  },
  contentContainer: {
    maxWidth: 1040,
  },
  contentContainerXS: {
    paddingBottom: theme.spacing['30'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationIngredientsGridSectionProps = ComponentProps<typeof Scrollspy.ScrollView> & {
  containerStyle?: ViewProps['style'];
};
